import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { hasPatientContact, PATIENT_CONTACT_NOTE } from '../../util/PatientData';

/**
 * Correo y celular del paciente, lado a lado, con la nota que explica para qué se piden.
 * Es el mismo bloque en el alta y en la ventana de editar datos. Sus campos se registran en
 * el formulario de la pantalla que lo usa, así que cuentan para habilitar el botón de guardar.
 */
@Component({
  selector: 'app-patient-contact-fields',
  templateUrl: './patient-contact-fields.component.html',
  styleUrls: ['./patient-contact-fields.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class PatientContactFieldsComponent
{
  @Input() public email: string;
  @Output() public emailChange: EventEmitter<string> = new EventEmitter<string>();

  @Input() public phone: string;
  @Output() public phoneChange: EventEmitter<string> = new EventEmitter<string>();

  // La nota se pone en ámbar si faltan los dos (en la ventana de editar)
  @Input() public warnWhenMissing: boolean = false;

  public readonly note: string = PATIENT_CONTACT_NOTE;

  get missingContact(): boolean
  {
    return !hasPatientContact(this.email, this.phone);
  }

  public onEmailChange(value: string): void
  {
    this.email = value;
    this.emailChange.emit(value);
  }

  public onPhoneChange(value: string): void
  {
    // Sólo dígitos: el celular se guarda a 10 dígitos
    this.phone = (value ?? '').replace(/\D/g, '').slice(0, 10);
    this.phoneChange.emit(this.phone);
  }
}
